import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { isManualProduct } from "Utils/productUtils";
import React from "react";
import { CardFooter, ManualCardFooter } from "./CardFooter";
import { CardHeader, ManualCardHeader } from "./CardHeader";
import { DetailsCardWrapper } from "./styled";

interface Props {
  readonly product: InsuranceProduct;
  readonly showDetails?: boolean;
  readonly displayIssueDate?: boolean;
}

export const InsuranceDetailsCard = ({
  product,
  showDetails = false,
  displayIssueDate,
}: Props): React.ReactElement => {
  return (
    <DetailsCardWrapper insuranceDetailsCard>
      <CardHeader
        product={product}
        productIcon
        displayIssueDate={displayIssueDate}
      />
      <CardFooter product={product} showDetails={showDetails} />
    </DetailsCardWrapper>
  );
};

export const ManualInsuranceDetailsCard = ({
  product,
  showDetails = false,
}: Props): React.ReactElement | null => {
  if (!isManualProduct(product)) {
    return null;
  }
  return (
    <DetailsCardWrapper insuranceDetailsCard>
      <ManualCardHeader product={product} productIcon />
      <ManualCardFooter product={product} showDetails={showDetails} />
    </DetailsCardWrapper>
  );
};
